import React, { lazy, useState, Suspense } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Image, Carousel, Icon, BasicModal, MaskedLink } from '@hz-design-system/web-ui';

import ContentArticle from './ContentArticle';
import HubList from '../../CarsPageContent/components/HubList';
import VERLogo from '../../../../images/cars-page/VER-logo.webp';
import { trackGAEvent } from '../../../utils/gaTracking';

const ContentArticleHtml = lazy(() => import('./ContentArticleHtml'));

import Classes from './ContentArticles.scss';
import TContentArticles, { TContentItem } from 'types/TContentArticles';

type TContentArticlesProps = {
  contentArticles: TContentArticles;
  isLeasePage: boolean;
};

const ContentArticles = ({ contentArticles, isLeasePage }: TContentArticlesProps) => {
  const { t } = useI18nContext();
  const [modalContent, setModalContent] = useState<TContentItem | null>(null);

  const onClick = (article: TContentItem, contentId: string, articleId: string) => {
    trackGAEvent('Clicked', `${contentId}-${articleId}`);

    if (article.content) {
      setModalContent(article);
    }
  };

  return (
    <>
      {contentArticles.map((content, indexOfRow) =>
        content.key === 'popular-brands' ? (
          <HubList key={content.key} content={content} isLeasePage={isLeasePage} />
        ) : (
          <Carousel
            key={content.key}
            title={t(`cars.content.${content.key}.title`)}
            id={content.key}
            headerClassName="PageContent-offset Carousel-title"
          >
            {content.items.map((item, indexOfArticle) => (
              <ContentArticle
                key={item.key}
                item={item}
                eagerLoadImage={indexOfRow === 0 && indexOfArticle <= 1}
                onClick={() => onClick(item, content.key, item.key)}
                smallVariant={content.key === 'popular-models'}
              />
            ))}
          </Carousel>
        ),
      )}
      {Boolean(modalContent) && modalContent && (
        <BasicModal
          className={Classes.articleModal}
          title={t('cars.content.ev-articles.title')}
          size="m"
          onClose={() => setModalContent(null)}
        >
          <Image
            className={Classes.modalImage}
            src={modalContent.images[3]}
            alt={t(`cars.content.items.${modalContent.key}.alt`)}
            srcSet={`${modalContent.images[2]} 530w, ${modalContent.images[3]} 2x`}
            loading="eager"
            decoding="sync"
            //@ts-expect-error -- DS issue
            aspectRatio=""
          />
          <Suspense fallback={null}>
            <ContentArticleHtml contentKey={modalContent.key} />
          </Suspense>
          <div className={Classes.partnerFooter}>
            {/* @ts-expect-error -- DS issue */}
            <Image alt="VER logo" src={VERLogo} aspectRatio="" />
            <div className={Classes.partnerCopy}>
              <p>Informatie tot stand gekomen met partner</p>
              <MaskedLink
                href="https://www.evrijders.nl/over-ver?utm_source=marktplaats&utm_medium=banner&utm_campaign=zoekmachinepilot"
                onClick={() => trackGAEvent('Clicked', 'Partner-modal')}
              >
                Vereniging Elektrische Rijders
                <Icon name="external-link" color="background-primary-button-default" />
              </MaskedLink>
            </div>
          </div>
        </BasicModal>
      )}
    </>
  );
};

export default ContentArticles;
